import { createTheme } from '@mui/material/styles';

import breakpoints from 'utils/breakpoints';
import { getColor } from 'utils/colors';
import mixins from 'utils/mixins';
import { remCalc } from 'utils/remCalc';

const theme = createTheme({
	breakpoints: breakpoints,
	mixins: mixins,
});

export const overrides = {
	'.verticalTextThreeSlides__section': {
		marginBottom: remCalc(50),
		'&.padding-normal': {
			paddingTop: remCalc(30),
			paddingBottom: remCalc(30),
			[theme.breakpoints.up('sm')]: {
				paddingTop: remCalc(100),
				paddingBottom: remCalc(100),
			},
		},
		'&.margin-flush': {
			marginBottom: 0,
		},
		'.verticalTextThreeSlides__grid': {
			'.verticalTextThreeSlides__grid_inner': {
				position: 'relative',
				'.verticalTextThreeSlides__wrapper': {
					'.verticalTextThreeSlides__slide': {
						'.verticalTextThreeSlides__slide_inner': {
							position: 'relative',
							'&.verticalTextThreeSlides__slide_link': {
								display: 'flex',
								width: '100%',
								color: 'inherit',
								textDecoration: 'none',
							},
							[theme.breakpoints.up('lg')]: {
								'&:hover .verticalTextThreeSlides__slide_title_wrapper .verticalTextThreeSlides__link_holder .verticalTextThreeSlides__link, &:focus-visible .verticalTextThreeSlides__slide_title_wrapper .verticalTextThreeSlides__link_holder .verticalTextThreeSlides__link': {
									backgroundColor: 'white',
									color: getColor('ivory', 800),
								},
							},
							[theme.breakpoints.down('ms')]: {
								display: 'flex',
								flexDirection: 'column',
								width: '100%',
							},
							[theme.breakpoints.up('ms')]: {
								paddingLeft: remCalc('66px'),
								'&.hideLabels': {
									paddingLeft: 0,
								}
							},
							'.verticalTextThreeSlides__slide_title_wrapper': {
								aspectRatio: '16 / 9',
								backgroundRepeat: 'no-repeat',
								backgroundPosition: 'center',
								backgroundSize: 'cover',
								position: 'relative',
								display: 'flex',
								alignItems: 'flex-end',
								justifyContent: 'flex-start',
								padding: remCalc('32px 32px 74px'),
								[theme.breakpoints.down('ms')]: {
									order: 2,
								},
								[theme.breakpoints.up('ms')]: {
									padding: remCalc('48px 48px 98px'),
									width: '100%',
								},
								[theme.breakpoints.up('xl')]: {
									aspectRatio: '2.5 / 1',
								},
								'.verticalTextThreeSlides__slide_title_wrapper__title': {
									margin: '0',
									fontFamily: 'var(--heading-font)',
									fontSize: '18px',
									fontWeight: '400',
									lineHeight: '24px',
									textTransform: 'uppercase',
									letterSpacing: '.5px',
									color: getColor('white',100),
									[theme.breakpoints.up('ms')]: {
										fontSize: '20px',
										lineHeight: '26px',
									},
								},
								'.verticalTextThreeSlides__link_holder': {
									display: 'flex',
									alignItems: 'flex-end',
									justifyContent: 'flex-end',
									position: 'absolute',
									right: remCalc('0'),
									bottom: 'auto',
									top: remCalc('0'),
									[theme.breakpoints.up('sm')]: {
										right: remCalc('48px'),
										bottom: remCalc('48px'),
									},
									[theme.breakpoints.up('ms')]: {
										right: remCalc('110px'),
										bottom: remCalc('48px'),
										'&.hideLabels': {
											right: remCalc('48px'),
											bottom: remCalc('48px'),
										}
									},
									'.verticalTextThreeSlides__link': {
									    display: 'flex',
										// backgroundColor: 'blue',
										alignItems: 'center',
										justifyContent: 'center',
										borderRadius: remCalc('4px'),
										height: remCalc('52px'),
										width: remCalc('52px'),
										backgroundColor: 'white',
										color: getColor('ivory', 800),
										transition: 'all var(--transition-duration) var(--transition-timing)',
										'svg': {
											height: remCalc('15'),
											width: remCalc('15'),
										},
										[theme.breakpoints.down('sm')]: {
											position: 'absolute',
											top: remCalc(30),
											right: remCalc(20),
										},
										[theme.breakpoints.up('lg')]: {
											...theme.mixins.glass,
											height: remCalc('52'),
											width: remCalc('52'),
											color: 'white',
											'svg': {
												height: remCalc('20'),
												width: remCalc('20'),
											},
										}
									}
								}
							},
							'.verticalTextThreeSlides__vertical_text_wrapper': {
								display: 'flex',
								justifyContent: 'center',
								[theme.breakpoints.down('ms')]: {
									width: '100%',
									order: 1,
								},
								[theme.breakpoints.up('ms')]: {
									position: 'absolute',
									top: '100%',
									left: '0',
									transform: 'rotate(-90deg)',
									transformOrigin: 'top left',
								},
								'&.slide_1': {
									justifyContent: 'flex-start',
									[theme.breakpoints.up('ms')]: {
										justifyContent: 'flex-end',
									}
								},
								'&.slide_3': {
									justifyContent: 'flex-end',
									[theme.breakpoints.up('ms')]: {
										justifyContent: 'flex-start',
									}
								},
								'.verticalTextThreeSlides__vertical_text_wrapper_label': {
									marginBottom: remCalc('24px'), 
									marginTop: remCalc('0'),
									fontFamily: 'var(--heading-font)',
									fontSize: remCalc('28px'),
									fontWeight: '400',
									lineHeight: remCalc('32px'),
									textTransform: 'uppercase',
									letterSpacing: remCalc('.5px'),
									[theme.breakpoints.only('sm')]: {
										fontSize: remCalc('40px'),
										lineHeight: remCalc('43px'),
									},
									[theme.breakpoints.up('ms')]: {
										marginBottom: remCalc('32px'),
										fontSize: remCalc('49px'),
										lineHeight: remCalc('54px'),
									},
								}
							}
						}
					}
				},
				'.verticalTextThreeSlides__title_wrapper': {
					position: 'absolute',
					left: remCalc('32px'),
					zIndex: '9',
					bottom: remCalc('32px'),
					pointerEvents: 'none',
					[theme.breakpoints.up('ms')]: {
						left: remCalc('114px'),
						'&.hideLabels': {
							left: remCalc('48px'),
						},
						bottom: remCalc('40px'),
					},
					'.verticalTextThreeSlides__title_wrapper__title': {
						margin: '0',
						fontFamily: 'var(--heading-font)',
						fontSize: remCalc('28px'),
						fontWeight: '400',
						lineHeight: remCalc('32px'),
						textTransform: 'capitalize',
						letterSpacing: remCalc('.5px'),
						color: getColor('white',100),
						[theme.breakpoints.up('ms')]: {
							fontSize: remCalc('49px'),
							lineHeight: remCalc('54px'),
						}
					}
				}
			}
		}
	}
}

const styles = {};

export default styles;